module.exports = __webpack_public_path__ + "img/round.41c6397b.png";